<template>
  <div class="page-content" style="margin-top: 20px">
    <el-row class="search-title common-table-top">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">产品详情</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
      </el-col>
    </el-row>
    <el-row class="box-content">
      <div class="box-content-div form-submit-page">
        <el-form :inline="false" :model="formInline" class="box-content-form form-content-check" label-width="100px">
          <el-form-item label="商品类型:" prop="">
            <el-select ref="input" v-model="formInline.pro_type" placeholder="请选择" class="product_type">
              <el-option
                v-for="item in productType"
                :key="item.productId"
                :label="item.name"
                :value="item.productId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品编码:" prop="pro_code" v-if="formInline.pro_type === 1">
            <el-input v-model="formInline.pro_code" disabled></el-input>
          </el-form-item>
          <el-form-item label="优惠券链接:" prop="quan_url" v-if="formInline.pro_type === 2">
            <div style="color: #c0c4cc;">{{formInline.quan_url}}</div>
          </el-form-item>
          <el-form-item label="商品名称:">
            <el-input v-model="formInline.name" placeholder="" disabled></el-input>
          </el-form-item>
          <el-form-item label="所需积分:">
            <el-input v-model="formInline.integral" placeholder="" disabled></el-input>
          </el-form-item>
          <el-form-item label="所需金额:">
            <el-input v-model="formInline.price" placeholder="" disabled></el-input>
          </el-form-item>
          <el-form-item label="排序:">
            <el-input v-model="formInline.sort" placeholder="" disabled></el-input>
          </el-form-item>
          <el-form-item label="兑换范围:">
            <el-select v-model="memberValue" multiple placeholder="请选择" disabled class="product_type">
              <el-option
                v-for="item in memberOptions"
                :key="item.id"
                :label="item.level_title"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="库存:">
            <el-input v-model="formInline.stock" placeholder="" disabled></el-input>
          </el-form-item>
          <el-form-item label="主展示图:">
            <img :src="formInline.pic_url" class="main-image">
          </el-form-item>
          <el-form-item label="图文详情:" class="picture-text-item">
            <div v-html="formInline.description"></div>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
  </div>
</template>
<script>
import { getProductDetails, getMemberLevelList } from '@/api/customer.js'
export default {
  name: '',
  data () {
    return {
      productType: [
        {
          name: '实物',
          productId: 1
        },
        {
          name: '优惠券',
          productId: 2
        }
      ],
      formInline: {},
      memberValue: [],
      memberOptions: []
    }
  },
  methods: {
    getData() {
      let id = this.$route.query.id
      getProductDetails(id).then((res) => {
        this.formInline = res.data.data
        this.formInline.price = this.formInline.price / 100
        if (this.formInline.grade_list !== '') {
          for (let one of this.formInline.grade_list.split(',')) {
            this.memberValue.push(parseInt(one))
          }
        }
      })
    },
    getMemberList() {
      getMemberLevelList().then(res => {
        this.memberOptions = res.data.data.list
      })
    }
  },
  created() {
    this.getData()
    this.getMemberList()
  },
  components: {
  }
}
</script>

<style scoped>
.sign-manage-title {
  background: #ecf6ff;
  border: 1px solid #E4e4e4;
  height:60px;
  padding:10px;
  line-height: 40px;
  margin-top: 10px;
}
.add-btn{
  height: 30px;
  padding: 0 10px;
  border-radius: 20px;
  text-align: center;
  line-height: 30px;
  float: right;
  color: #fff;
  font-size: 14px;
  background: #4882ff;
  margin-top: 5px;
  cursor: pointer;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
.box-content-div {
  width: 520px;
  margin: 0 auto;
}
.box-content-form {
  width: 520px;
  margin: 0 auto;
  margin-top: 10px;
  text-align: center;
}
.box-content-form .el-form-item {
  width: 520px;
}
.el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.main-image {
  height: 175px;
  width: 175px;
}
</style>
